module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_05-Ourevent_default.82568b2f.png";